<template>
  <div>
    <v-data-table
      :loading="loading"
      :headers="headersByType"
      :items="devices"
      :server-items-length="meta.total"
      :footer-props="footerProps"
      :options="options"
      :page="page"
      :items-per-page="itemsPerPage"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :multi-sort="multiSort"
      v-on="listeners"
    >
      <template v-slot:item.type_name="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <span
              v-bind="attrs"
              class="d-inline-block text-truncate"
              style="max-width: 130px;"
              v-on="on"
            >
              {{ item.type.name }}
            </span>
          </template>
          <span style="max-width: 500px; float: left; word-wrap: break-word;">{{
            item.type.name
          }}</span>
        </v-tooltip>
      </template>

      <template v-slot:item.person_first_name="{ item }">
        {{ item.person.first_name }}
      </template>

      <template v-slot:item.person_last_name="{ item }">
        <span class="mr-2">{{ item.person.last_name }}</span>
        <router-link
          class="text-decoration-none"
          target="_blank"
          :to="{
            name: 'persons.show',
            params: { id: item.person_id }
          }"
        >
          <v-icon small>mdi-eye-outline</v-icon>
        </router-link>
      </template>

      <template v-slot:item.expiry_date="{ item }">
        {{ item.expiry_date | dateFormat }}
      </template>

      <template v-slot:item.status_id="{ item }">
        <v-chip
          v-if="item.status.color"
          :color="item.status.color"
          text-color="white"
          small
        >
          {{ item.status.name }}
        </v-chip>
      </template>

      <template v-slot:item.states="{ item }">
        <v-chip
          v-for="state in item.states"
          :key="state.id"
          class="mr-1"
          color="primary"
          x-small
          dark
          outlined
        >
          {{ state.name }}
        </v-chip>
      </template>

      <template v-slot:item.action="{ item }">
        <div class="text-center">
          <v-list-item @click="$emit('show', item)">
            <v-list-item-title>
              <v-icon class="mr-1" small>mdi-eye</v-icon>
              {{ $t('ITEM.VIEW') }}
            </v-list-item-title>
          </v-list-item>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export const ALL = 'all';
export const PERSON = 'person';
export const DEVICE = 'device';
export const WAREHOUSE = 'warehouse';
export const types = Object.freeze({
  ALL,
  PERSON,
  DEVICE,
  WAREHOUSE
});
import { isEqual } from 'lodash';
import { dateFormat } from '@/modules/_global/filters';

export default {
  name: 'DeviceList',

  filters: {
    dateFormat
  },

  props: {
    devices: {
      type: Array,
      required: true
    },
    meta: {
      type: Object,
      default: () => ({
        total: -1
      })
    },
    type: {
      type: String,
      default: ALL,
      validator: prop => Object.values(types).includes(prop)
    },
    options: {
      type: Object,
      default: () => {}
    },
    page: {
      type: Number,
      default: 1
    },
    itemsPerPage: {
      type: Number,
      default: 10
    },
    sortBy: {
      type: [String, Array],
      default: 'id'
    },
    sortDesc: {
      type: [Boolean, Array],
      default: false
    },
    multiSort: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    footerProps: {
      showFirstLastPage: true,
      itemsPerPageOptions: [10, 50, 100]
    },
    columnsByType: {
      [PERSON]: [0, 1, 4, 5, 6, 7, 8, 10],
      [DEVICE]: [0, 1, 2, 3, 4, 5, 6, 7, 8, 10],
      [WAREHOUSE]: [0, 1, 6, 5, 4, 9, 10],
      [ALL]: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    }
  }),

  computed: {
    listeners: function() {
      return Object.assign({}, this.$listeners, {
        'update:options': this.updateOptions
      });
    },

    headers() {
      return [
        {
          text: this.$t('ITEM.ID'),
          align: 'left',
          sortable: true,
          value: 'id'
        },
        {
          text: this.$t('ITEM.TYPE'),
          value: 'type_name'
        },
        {
          text: this.$t('PROFILE.FIRST_NAME'),
          value: 'person_first_name'
        },
        {
          text: this.$t('PROFILE.LAST_NAME'),
          value: 'person_last_name'
        },
        {
          text: this.$t('DEVICES.PHONE'),
          value: 'phone'
        },
        {
          text: this.$t('DEVICES.SERIAL_NUMBER'),
          value: 'serial_number'
        },
        {
          text: this.$t('DEVICES.DEVICE_CODE'),
          value: 'device_code'
        },
        {
          text: this.$t('DEVICES.EXPIRY_DATE'),
          value: 'expiry_date'
        },
        {
          text: this.$t('ITEM.STATUS'),
          value: 'status_id'
        },
        {
          text: this.$t('DEVICES.STATE'),
          sortable: false,
          value: 'states'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          align: 'center'
        }
      ];
    },

    columns() {
      return this.columnsByType[this.type];
    },

    headersByType() {
      return this.columns.map(i => this.headers[i]).filter(Boolean);
    }
  },

  methods: {
    updateOptions(options) {
      if (isEqual(options, this.options)) {
        return;
      }

      this.$emit('update:options', options);
    }
  }
};
</script>
